<template>
  <section class="contact-page">
    <div class="container">
      <div class="contact-grid">
        <div class="contact-header">
          <span class="sub-title">{{ $t('contactUsFormTitle') }}</span>
          <h1>
            {{ $t('contactUsTitleOne') }}
            <span>{{ $t('contactUsTitleTwo') }}</span>
          </h1>

          <div class="context-text">
            <p class="meeting-intro">
              {{ $t('contactUsMeetingIntro') }}
            </p>
            <ul class="benefit-list">
              <li>{{ $t('contactUsBenefit1') }}</li>
              <li>{{ $t('contactUsBenefit2') }}</li>
              <li>{{ $t('contactUsBenefit3') }}</li>
              <li>{{ $t('contactUsBenefit4') }}</li>
            </ul>
          </div>
        </div>

        <div class="contact-form-container">
          <h2>{{ $t('contactUsFormTitle') }}</h2>
          <form @submit.prevent="submitForm" class="qubiz-form">
            <div class="form-group">
              <input
                type="text"
                id="name"
                v-model="form.name"
                required
                placeholder=" "
              />
              <label for="name">{{ $t('contactUsFormName') }}</label>
            </div>
            <div class="form-group">
              <input
                type="email"
                id="email"
                v-model="form.email"
                required
                placeholder=" "
              />
              <label for="email">{{ $t('contactUsFormEmail') }}</label>
            </div>
            <div class="form-group">
              <textarea
                id="message"
                v-model="form.message"
                required
                placeholder=" "
              ></textarea>
              <label for="message">{{ $t('contactUsFormMessage') }}</label>
            </div>

            <div class="form-actions">
              <button
                type="submit"
                class="primary-button"
                :disabled="isSubmitting"
              >
                <span v-if="!isSubmitting">{{
                  $t('contactUsFormSubmit')
                }}</span>
                <span v-else class="loader"></span>
              </button>

              <transition name="fade">
                <div v-if="status === 'success'" class="feedback-msg success">
                  <i class="fas fa-check-circle"></i>
                  {{ $t('emailSentSuccess')}}
                </div>
                <div v-else-if="status === 'error'" class="feedback-msg error">
                  <i class="fas fa-exclamation-circle"></i>
                  {{$t('emailSentError')}}
                </div>
              </transition>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  <ContactFooter />
</template>

<script>
import { API_ROUTES } from '@/config.js'

export default {
  name: 'ContactPage',
  data () {
    return {
      isSubmitting: false,
      status: null,
      form: {
        name: '',
        email: '',
        message: ''
      }
    }
  },
  methods: {
    async submitForm () {
      this.status = null
      if (!this.isValidEmail(this.form.email)) {
        this.status = 'error'
        return
      }

      this.isSubmitting = true
      try {
        await fetch(`${API_ROUTES.BASE_URL}${API_ROUTES.SEND_EMAIL}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.form)
        })

        this.status = 'success'
        this.form = { name: '', email: '', message: '' }
        setTimeout(() => {
          this.status = null
        }, 5000)
      } catch (error) {
        console.error('Error:', error)
        this.status = 'error'
      } finally {
        this.isSubmitting = false
      }
    },
    isValidEmail (email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    }
  }
}
</script>

<style scoped>
.contact-page {
  padding: 100px 0;
  background-color: #f7f9fc;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 60px;
  align-items: center;
}

.contact-header h1 {
  margin-top: 0.5rem;
  font-size: 3.5rem;
  text-transform: uppercase;
  color: var(--primary-color);
  line-height: 1;
  margin-bottom: 2.5rem;
}

.context-text {
  margin-bottom: 3rem;
  max-width: 550px;
}

.context-text p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: var(--text-color);
  opacity: 0.9;
}

.meeting-intro {
  font-weight: 700;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.benefit-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.benefit-list li {
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  font-size: 1rem;
  line-height: 1.4;
}

.benefit-list li::before {
  content: '•';
  color: var(--secondary-color);
  font-weight: bold;
  position: absolute;
  left: 0;
  font-size: 1.5rem;
  line-height: 1;
}

.sub-title {
  font-family: var(--secondary-font);
  color: var(--secondary-color);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.875rem;
}

.contact-details {
  margin-top: 3rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 20px;
}

.icon-box {
  width: 50px;
  height: 50px;
  background-color: var(--primary-color);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}

.info small {
  display: block;
  color: #666;
  margin-bottom: 4px;
}

.info a {
  font-family: var(--secondary-font);
  font-weight: 700;
  color: var(--primary-color);
  font-size: 1.25rem;
  transition: color 0.2s;
}

.contact-form-container {
  background: white;
  padding: 60px;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);
}

.contact-form-container h2 {
  margin-top: 0;
  margin-bottom: 2.5rem;
  font-size: 2rem;
}

.qubiz-form .form-group {
  position: relative;
  margin-bottom: 40px;
}

.qubiz-form input,
.qubiz-form textarea {
  width: 100%;
  padding: 12px 0;
  border: none;
  border-bottom: 2px solid #e0e0e0;
  background: transparent;
  font-family: var(--primary-font);
  font-size: 1rem;
  outline: none;
  transition: border-color 0.3s;
}

.qubiz-form label {
  position: absolute;
  left: 0;
  top: 12px;
  color: #999;
  pointer-events: none;
  transition: 0.3s ease all;
}

.qubiz-form input:focus ~ label,
.qubiz-form input:not(:placeholder-shown) ~ label,
.qubiz-form textarea:focus ~ label,
.qubiz-form textarea:not(:placeholder-shown) ~ label {
  top: -20px;
  font-size: 0.8rem;
  color: var(--secondary-color);
  font-weight: 700;
}

.qubiz-form input:focus,
.qubiz-form textarea:focus {
  border-bottom-color: var(--secondary-color);
}

.form-actions {
  margin-top: 30px;
}

.feedback-msg {
  margin-top: 20px;
  padding: 12px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}

.feedback-msg.success {
  background-color: rgba(43, 189, 211, 0.1);
  color: var(--secondary-color);
}

.feedback-msg.error {
  background-color: rgba(255, 0, 0, 0.05);
  color: #d93025;
}

.loader {
  width: 20px;
  height: 20px;
  border: 2px solid #ffffff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.primary-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (min-width: 992px) {
  .contact-grid {
    grid-template-columns: 1fr 1.2fr;
    gap: 100px;
  }

  .primary-button {
    width: auto;
  }
}
</style>
